import React from 'react'
import { FaFacebookSquare, FaInstagramSquare, FaLinkedin, FaLinkedinIn, FaWhatsappSquare } from 'react-icons/fa'
import "./footer.css";

function Footer() {
    return (
        <section className='footer'>
            <div>
                <p>© 2025 All rights reserved</p>
            </div>


            <div className="social-icons">
                 <a href="https://www.facebook.com/profile.php?id=61577395404506" target="_blank" rel="noopener noreferrer">
                    <FaFacebookSquare />
                </a>
                <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                    <FaInstagramSquare />
                </a>

                <a href="https://api.whatsapp.com/send?phone=919884001047" target="_blank" rel="noopener noreferrer">
                    <FaWhatsappSquare />
                </a>

                <a href="https://www.linkedin.com/in/farzana-rahman-b02a74352" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                </a>
            </div>
        </section>
    );
}

export default Footer;
